/**
 * Generated emote names
 * DO NOT EDIT - Generated by tools/texturepacker/multi-size-packer.ts
 */

/** All available emote names (without emote_ prefix) */
export const EMOTE_NAMES = [
  'ace',
  'acepilot',
  'alert',
  'angry',
  'ass',
  'bananas',
  'bang',
  'bear',
  'beer',
  'bird',
  'blah',
  'bluecap',
  'bluefire',
  'bomb',
  'bones',
  'boom',
  'bot',
  'bro',
  'bs',
  'bum',
  'camp',
  'canttouch',
  'chicken',
  'clap',
  'cool',
  'cry',
  'dab',
  'ddd',
  'derp',
  'devil',
  'devilfury',
  'dog',
  'doglol',
  'dogoh',
  'dogrr',
  'doh',
  'dragon',
  'drool',
  'drunk',
  'elon',
  'facepalm',
  'fgun',
  'fguns',
  'fire',
  'flushed',
  'fu',
  'fury',
  'gg',
  'ggwp',
  'godfather',
  'goli',
  'greedy',
  'h5',
  'hawkes',
  'heart',
  'hehe',
  'heli',
  'hellpilot',
  'hs',
  'inferno',
  'insult',
  'joke',
  'joker',
  'jolly',
  'kappa',
  'kim',
  'king1',
  'king2',
  'king3',
  'leader',
  'lol',
  'loser',
  'lotfl',
  'mime',
  'mine',
  'missibis',
  'monkey',
  'mvp',
  'nado',
  'narf',
  'ndt',
  'nerd',
  'nobot',
  'noheli',
  'noob1',
  'noob2',
  'noprow',
  'nyan',
  'old',
  'party',
  'party1',
  'party2',
  'peace',
  'pepe',
  'pigpilot',
  'pluto',
  'poo',
  'pooangry',
  'poobull',
  'poosad',
  'pred',
  'prow',
  'putin',
  'rage',
  'rambo',
  'raptor',
  'rat',
  'redcap',
  'redfire',
  'rekt',
  'revenge',
  'rip',
  'rolleyes',
  'sad',
  'salty',
  'salute',
  'shield',
  'shrug',
  'skullpilot',
  'steamr',
  'stop',
  'stopit',
  'sweeteyes',
  'tblue',
  'tdown',
  'tf',
  'thief',
  'think',
  'tired',
  'tred',
  'trump',
  'tup',
  'turtle',
  'turtled',
  'uplove',
  'vader',
  'victory',
  'watchingyou',
  'wave',
  'wflag',
  'wink',
  'yell',
  'yoda',
  'zzz',
] as const;

/** Emote name type */
export type EmoteName = (typeof EMOTE_NAMES)[number];
